module.exports = __webpack_public_path__ + "static/media/miesasiakas.80df11eb.svg";